import { handleResponse } from "../_helpers/handle-response";
import { authHeader } from "../_helpers/auth-header.js";
import { BASE_URL } from "../_constants/services.constants.js";

const modelManagementService = {
  getModelnSeriesList,
  getModelnSeriesByModelId,
  addModelnSeries,
  update,
  delete: _delete,
};

function getModelnSeriesList() {
  const requestOptions = { method: "GET", headers: authHeader() };
  return fetch(
    `${BASE_URL}/ModelManagement/GetModelnSeriesList`,
    requestOptions,
  ).then(handleResponse);
}
function getModelnSeriesByModelId(id) {
  const requestOptions = { method: "GET", headers: authHeader() };
  return fetch(
    `${BASE_URL}/ModelManagement/GetModelnSeriesByModelID` + id,
    requestOptions,
  ).then(handleResponse);
}
function addModelnSeries(formData) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: formData,
  };
  return fetch(
    `${BASE_URL}/ModelManagement/AddModelnSeries`,
    requestOptions,
  ).then(handleResponse);
}
function update(formData) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: formData,
  };
  console.log(formData);
  return fetch(
    `${BASE_URL}/ModelManagement/UpdateModelnSeries`,
    requestOptions,
  ).then(handleResponse);
}

function _delete(formData) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
    body: formData,
  };

  return fetch(
    `${BASE_URL}/ModelManagement/DeleteModelnSeries`,
    requestOptions,
  ).then(handleResponse);
}

export default modelManagementService;
